<!-- Sidebar de la suite: fila con ícono + label. Si el módulo tiene hijos, al
     pulsar abre su página (si el perfil puede verla) o cae en el primer flujo.
     Si no tiene hijos, navega a su link. Los subitems vienen en `item.children`. -->
<div class="suite-modules">
  @for (section of sections; track section.name) {
    <div class="suite-modules__section">
      <ul class="suite-modules__list">
        @for (item of section.items; track item.module.name) {
          <li class="suite-modules__item">
            @if (item.module.disabled) {
              <!-- Contratable pero no contratado: en gris, no navega. Teaser del plan. -->
              <span class="suite-modules__link is-disabled" title="No incluido en tu plan">
                @if (item.module.iconClass) {
                  <i class="suite-modules__fa" [class]="item.module.iconClass"></i>
                } @else {
                  <i class="inp-btn inp-icon-{{ item.module.icon || item.module.name }}-o"></i>
                }
                <span class="suite-modules__title">{{ moduleLabel(item.module.alias) }}</span>
              </span>
            } @else if (tieneHijos(item)) {
              <!-- Con hijos: abre su página o cae en el primer flujo. -->
              <button type="button" class="suite-modules__link"
                [class.is-active]="item.module.name === activeModule"
                [class.is-opened]="moduloEstaAbierto(item)"
                (click)="toggleModulo(item)">
                @if (item.module.iconClass) {
                  <i class="suite-modules__fa" [class]="item.module.iconClass"></i>
                } @else {
                  <i class="inp-btn inp-icon-{{ item.module.icon || item.module.name }}-o"></i>
                }
                <span class="suite-modules__title">{{ moduleLabel(item.module.alias) }}</span>
                <i class="fas fa-chevron-down suite-modules__chevron"></i>
              </button>
            } @else {
              <!-- Sin hijos: navega. -->
              <a class="suite-modules__link" [class.is-active]="item.module.name === activeModule"
                [routerLink]="linkPath(item.module.link)" [queryParams]="linkQuery(item.module.link)"
                (click)="elegirModulo(item)">
                @if (item.module.iconClass) {
                  <i class="suite-modules__fa" [class]="item.module.iconClass"></i>
                } @else {
                  <i class="inp-btn inp-icon-{{ item.module.icon || item.module.name }}-o"></i>
                }
                <span class="suite-modules__title">{{ moduleLabel(item.module.alias) }}</span>
              </a>
            }

            @if (tieneHijos(item) && moduloEstaAbierto(item)) {
              <ul class="suite-modules__children">
                @for (child of item.children; track child.name) {
                  <li class="suite-modules__child" [class.suite-modules__child--flujo]="esMenuDesplegable(child)">
                    @if (esMenuDesplegable(child)) {
                      <button type="button" class="suite-modules__child-link"
                        [class.is-opened]="estaAbierto(child)"
                        [class.is-active]="flujoSeleccionado(child)"
                        (click)="toggleFlujo(item, child)">
                        @if (child.count != null) {
                          <span class="suite-modules__count">{{ child.count }}</span>
                        }
                        <span class="suite-modules__child-label">{{ moduleLabel(child.alias) || child.name }}</span>
                        <i class="fas fa-chevron-down suite-modules__chevron"></i>
                      </button>
                    } @else {
                      <a class="suite-modules__child-link" [class.is-active]="hijoSeleccionado(child)"
                        [attr.aria-current]="hijoSeleccionado(child) ? 'page' : null"
                        [class.is-disabled]="child.disabled"
                        [routerLink]="child.disabled ? null : linkPath(child.link)"
                        [queryParams]="child.disabled ? null : linkQuery(child.link)"
                        (click)="elegirModulo(item)">
                        @if (child.count != null) {
                          <span class="suite-modules__count">{{ child.count }}</span>
                        }
                        {{ moduleLabel(child.alias) || child.name }}
                      </a>
                    }

                    <!-- Visibilidades del juicio abierto, o nivel 3 del catálogo (Mantenedores). -->
                    @if (child.children?.length && (!esMenuDesplegable(child) || estaAbierto(child))) {
                      <ul class="suite-modules__grandchildren">
                        @for (gc of child.children; track gc.name) {
                          <li class="suite-modules__grandchild">
                            <a class="suite-modules__grandchild-link" [class.is-active]="hijoSeleccionado(gc)"
                              [attr.aria-current]="hijoSeleccionado(gc) ? 'page' : null"
                              [class.is-disabled]="gc.disabled"
                              [routerLink]="gc.disabled ? null : linkPath(gc.link)"
                              [queryParams]="gc.disabled ? null : linkQuery(gc.link)"
                              (click)="elegirNieto(item, child)">
                              @if (gc.count != null) {
                                <span class="suite-modules__count">{{ gc.count }}</span>
                              }
                              {{ moduleLabel(gc.alias) || gc.name }}
                            </a>
                          </li>
                        }
                      </ul>
                    }
                  </li>
                }
              </ul>
            }
          </li>
        }
      </ul>
    </div>
  }
</div>
